<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { computed, ref } from "vue";
import type {
  ListDataInterface,
  SecondaryDataInterface,
  ToolTipInterface,
} from "@/types/ContentType";
import { useBuildingStore } from "@/store/building";
import type { FAQCategory } from "@/store/main/types/widgets-terms/terms";

import Button from "@/components/regularComponents/UIComponents/Button.vue";
import Price from "@/components/regularComponents/UIComponents/Project/PaymentCalculator/parts/Price.vue";

const props = defineProps<{
  items: SecondaryDataInterface["data"]["list"];
  SelectedTypeData?: ListDataInterface;
  allTypes?: FAQCategory[];
  activeType?: FAQCategory;
}>();

const emit = defineEmits<{
  (e: "select", item: FAQCategory): void;
}>();

const buildingStore = useBuildingStore();

const activeIndex = ref(0);

const onClick = (item: FAQCategory, index: number) => {
  emit("select", item);
  activeIndex.value = index;
};

const incomePerYear = computed(() =>
  props.SelectedTypeData?.tooltip?.reduce(sumReducer, 0)
);

const projectLowestPrices = computed(() => {
  const data = buildingStore.projectLowestPrices;
  const slug = props.activeType?.slug;

  if (!slug || !data) return;

  return data[slug];
});

const sumReducer = (acc: number, curr: ToolTipInterface) => (acc += Number(curr.amount));
</script>

<template>
  <div class="project-forecast__summary d-flex j-btw al-center">
    <div class="buttons-wrapper">
      <div class="buttons d-flex p-8 wrp-wrap" v-if="allTypes?.length">
        <Button
          v-for="(item, index) in allTypes"
          :key="index"
          :btnText="item?.title"
          :btnType="6"
          :class="['nowrap', { active: activeIndex === index }]"
          @click="onClick(item, index)"
        />
      </div>
    </div>

    <ul
      class="project-forecast__summary-prices d-flex"
      v-if="projectLowestPrices || incomePerYear"
      :key="activeIndex"
    >
      <Price
        label="TOTAL INVESTED"
        :price="projectLowestPrices"
        v-if="projectLowestPrices || projectLowestPrices == 0"
      />

      <Price label="INCOME PER YEAR" :price="incomePerYear" v-if="incomePerYear" />
    </ul>
  </div>
</template>
